import { Component, OnInit } from '@angular/core';
import { GatewayService } from 'src/app/gateway.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
//IMPORT POWERBI
import * as pbi from 'powerbi-client';
import { NgxPowerBiService } from 'ngx-powerbi';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { TipoServicioService } from '../tipo-servicio.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  private destroy$ = new Subject<void>();

	private powerBiService: NgxPowerBiService;
	private pbiContainerElement: HTMLElement;

	constructor(
		private router: Router,
		private localSave: LocalSaveService,
		private gateway: GatewayService,
		private spinner: NgxSpinnerService,
		private _tipoServicio: TipoServicioService,
	) {
		this.powerBiService = new NgxPowerBiService();
	}

	ngOnInit() {
		const user = this.localSave.get('usuarioPGV');
		if (!user || (user.idrol != 16 && user.idrol != 1 && user.idrol != 23 && user.idrol != 24)) {
			this.router.navigate(['/home']);
		}
		this._tipoServicio.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.showReport([]);
		});
	}

	ngAfterViewInit() {
		this.showReport([
			{
				"agency_names": "'Albrook Mall', 'Costa del Este', 'Test '"
			}
		]);
	}

	showReport(agencyNames) {
		// Report's Secured Token
		let accessToken = '';

		// Embed URL
		// let embedUrl = 'https://embedded.powerbi.com/reportEmbed?';
		let embedUrl = 'https://app.powerbi.com/reportEmbed?';

		// Report ID
		//let embedReportId = '5d6b9cef-c5ac-4836-815f-082ba6914a6e';//isoft
		// let embedReportId = '49dab7a8-d9c5-4dcb-9a40-7350d8ea681f'; //mov desa
		let embedReportId = 'beea8fba-4abc-43e2-ba95-25cdbd66784f'; //mov prod

		// Group ID
		let embedGroupId = '1e41269c-5735-4eea-b24b-8471b8b980fe';

		this.gateway.get('gettokenbi', {}).then((result: any) => {
			//console.log(result);
			// let auxres: any = result;
			// const config = {
			// 	type: 'report',
			// 	id: embedReportId,
			// 	embedUrl:
			// 		embedUrl +
			// 		'reportId=' + embedReportId +
			// 		'&groupId=' + embedGroupId,
			// 	accessToken: auxres.access_token,
			// 	settings: {
			// 		filterPaneEnabled: true,
			// 		navContentPaneEnabled: true
			// 	}
			// };

			const token = JSON.parse(result.TOKEN);
			if (this.localSave.get('usuarioPGV').esDistribuidor) {
				// embedUrl += `&filter=TICKET/name in (${agencyNames}) and usuarioHU/agencia in (${agencyNames})`;
				embedUrl += `&filter=contrata/iddistribuidor in (${this._tipoServicio.getValorActual().IDU})`;
				// embedUrl += `filter=distribuidor/iddistribuidor eq ${this.localSave.get('usuarioPGV').IDU}`;
				// embedUrl += `iddistribuidor=${this.localSave.get('usuarioPGV').IDU}`;
			}

			const config = {
				type: 'report',
				id: result.REPORT,
				embedUrl: embedUrl,
				accessToken: token.access_token,
				tokenType: pbi.models.TokenType.Aad,
				settings: {
					filterPaneEnabled: false,
					navContentPaneEnabled: true
				}
			};

			this.pbiContainerElement = <HTMLElement>(document.getElementById('pbi-container'));
			this.powerBiService.embed(this.pbiContainerElement, config);

			let report = <pbi.Report>this.powerBiService.embed(this.pbiContainerElement, config);

			// Report.off removes a given event handler if it exists.
			report.off("loaded");

			// Report.on will add an event handler which prints to Log window.
			report.on("loaded", function () {
				// console.log("Loaded");
			});
		}).catch(function (e) {
		});
	}

	descargatodo() {
		this.spinner.show();
		this.gateway.get('exportaradmindashcount', {}).then(
			(data: any) => {
				if (data.rows[0].cantidad > 0) {
					this.prepararinformacion(data.rows[0].cantidad, 0, null);
				} else {
					//this.snackbar.open('No hay clientes para esta campaña.', 'Cerrar', { duration: 3000, });
					this.spinner.hide();
				}
			}
		);
	}

	prepararinformacion(count, index, data) {
		//console.log('==========')
		// console.log({ IDCAMPANA: campana, LIMIT: 100, OFFSET: index })
		// console.log('==========')
		this.gateway.get('exportaradmindashlote', { LIMIT: 1000, OFFSET: index }).then(
			(result: any) => {
				if (data) {
					data = data.concat(result.rows)
				} else {
					data = result.rows;
				}
				// console.log('==========')
				// console.log(data)
				// console.log('==========')
				let control = index + 1000;
				if (control <= count) {
					// console.log('==========')
					// console.log(control)
					// console.log('==========')
					this.prepararinformacion(count, control, data);
				} else {
					this.descargarexcel(data);
				}
			}
		);
	}

	descargarexcel(ctr) {
		const fileName = 'Data_dashboard-' + Date.now();
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ctr);
		XLSX.utils.book_append_sheet(wb, ws);

		const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
		saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
		this.spinner.hide();
	}


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
